<template>
    <Header></Header>
    <Left></Left>
    <section class="container pdf_area_class">
        <div>
            <div class="area_title">
                <p>민원</p>
            </div>
            <div class="area_body">
                <div class="area_section">
                    <div class="area_form">
                        <div class="area_form_title"><p>민원 세부내역</p></div>
                        <div class="area_form_body">
                            <div class="area_row">
                                <div class="area_col_row" style="flex-direction: row">
                                    <div class="area_col" style="width: 50%; border-bottom: 0; border-right: 1px solid #d9d9d9">
                                        <div class="area_col_head"><label class="starMark">1. 작성일</label></div>
                                        <div class="area_col_body">
                                            <div class="datepicker">
                                                <input type="date" v-model="state.data.createDate" />
                                            </div>
                                        </div>
                                    </div>

                                    <div class="area_col" style="width: 50%; border-bottom: 0; border-right: 1px solid #d9d9d9">
                                        <div class="area_col_head"><label class="starMark">2. 작성자</label></div>
                                        <div class="area_col_body">
                                            <div class="">
                                                <input type="text" v-model="state.data.writer" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="area_row">
                                <div class="area_col_row" style="flex-direction: row">
                                    <div class="area_col" style="width: 50%; border-bottom: 0; border-right: 1px solid #d9d9d9">
                                        <div class="area_col_head"><label class="starMark">3. 문의자 이름</label></div>
                                        <div class="area_col_body">
                                            <div class="">
                                                <input type="text" v-model="state.data.complainant" />
                                            </div>
                                        </div>
                                    </div>

                                    <div class="area_col" style="width: 50%; border-bottom: 0; border-right: 1px solid #d9d9d9">
                                        <div class="area_col_head"><label class="starMark">4. 문의자 구분</label></div>
                                        <div class="area_col_body">
                                            <div class="select-wrap">
                                                <select v-model="state.data.complainantType" class="w250">
                                                    <option value="">선택해주세요.</option>
                                                    <option v-for="item in complainantTypeList" :value="item.key">
                                                        {{ item.name }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="area_row">
                                <div class="area_col_head"><label class="starMark">5. 문의자 연락처</label></div>
                                <div class="area_col_body">
                                    <div class="">
                                        <input type="text" v-model="state.data.phoneNum" />
                                    </div>
                                </div>
                            </div>

                            <div class="area_row">
                                <div class="area_col_head"><label class="starMark">6. 문의 유형</label></div>
                                <div class="area_col_body">
                                    <div class="select-wrap">
                                        <select v-model="state.data.type" class="w250">
                                            <option value="">선택해주세요.</option>
                                            <option v-for="item in typeList" :value="item.key">
                                                {{ item.name }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="area_row">
                                <div class="area_col_head"><label class="starMark">7. 문의 제목</label></div>
                                <div class="area_col_body">
                                    <div class="full">
                                        <input type="text" v-model="state.data.title" />
                                    </div>
                                </div>
                            </div>

                            <div class="area_row">
                                <div class="area_col_head"><label>8. 문의 내용</label></div>
                                <div class="area_col_body textarea_wrap">
                                    <div class="full">
                                        <textarea v-model="state.data.content"></textarea>
                                        <p v-text="state.data.content"></p>
                                    </div>
                                </div>
                            </div>
                            <div class="area_row">
                                <div class="area_col_head"><label class="starMark">9. 조치 결과</label></div>
                                <div class="area_col_body">
                                    <div class="select-wrap">
                                        <select v-model="state.data.resultType" class="w250">
                                            <option value="">선택해주세요.</option>
                                            <option v-for="item in resultTypeList" :value="item.key">
                                                {{ item.name }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="area_form_foot">
                            <div class="area_button">
                                <button type="button" class="" @click="router.push({ name: 'complain' })">목록</button>
                                <template v-if="state.mode">
                                    <button type="button" class="active" @click="confirmAdd">등록</button>
                                </template>
                                <template v-else>
                                    <button type="button" class="active" @click="confirmModify">저장</button>
                                    <button type="button" class="danger" @click="confirmRemove">삭제</button>
                                </template>

                                <button type="button" class="" @click="reset">초기화</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <Spinner :is-full-page="true" v-if="state.isLoading"></Spinner>
    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        :gubun="state.gubun"
        @close="closeModal"
        @callback="callbackModal"
    ></ModalDefault>
</template>
<script lang="ts" config>
    import {
        Left,
        Header,
        reactive,
        apiService,
        onMounted,
        router,
        ModalDefault,
        types,
        getMessageByCode,
        CommonUtils,
        CommonOptions,
        ItemAdd,
        watch,
        useRoute,
        Spinner,
        ref,
        userStore,
    } from "@/BaseComponent";

    export default {
        components: { ModalDefault, ItemAdd, Left, Header, Spinner },

        setup() {
            const user = userStore();
            const route = useRoute();
            const state = reactive({
                idx: 0 as number,
                data: {} as types.complain.ComplainVOForApi | any,
                mode: true as boolean, // true: insert, false: update

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,

                file: [] as Array<File>,
                gubun: 1 as 1 | 2 | 3, // 1: update, 2: delete, 3: insert

                isLoading: false,
            });

            const complainantTypeList = [
                { key: 1, name: "여성폭력 피해자" },
                { key: 2, name: "종결 내담자" },
                { key: 3, name: "제보자" },
                { key: 4, name: "유관기관" },
                { key: 5, name: "성매매 알선자" },
                { key: 6, name: "성매수자" },
                { key: 7, name: "경찰/검찰/법원" },
                { key: 8, name: "기타" },
            ];

            const typeList = [
                { key: 1, name: "타피해 지원 문의" },
                { key: 2, name: "제보문의" },
                { key: 3, name: "민원" },
                { key: 4, name: "기타" },
            ];

            const resultTypeList = [
                { key: 1, name: "대기" },
                { key: 2, name: "완료" },
            ];

            onMounted(() => {
                if (route.params.id) {
                    state.idx = Number(route.params.id);
                    detail();
                    state.mode = false;
                } else {
                    state.mode = true;
                    state.data.createDate = CommonUtils.getToday("");
                    state.data.writer = user.userInfo.name as string;
                }
            });

            watch(
                () => route.params.id,
                () => {
                    if (route.params.id) {
                        state.idx = Number(route.params.id);
                        detail();
                        state.mode = false;
                    } else {
                        state.mode = true;
                    }
                },
            );

            const detail = async () => {
                state.file = [];
                const res = await apiService.complain.detail(state.idx);

                if (res.returnCode === 0) {
                    if (res.data) {
                        state.data = res.data;

                        state.data.createDate = CommonUtils.dateFormatYYYYMMDD(state.data.date, "-");
                    }
                }
            };

            const showModal = () => {};

            const closeModal = () => {
                if (state.modalTab === 3) {
                    router.back();
                } else {
                    state.isShowModal = false;
                }
            };

            const reset = () => {
                if (state.idx) {
                    detail();
                } else {
                    state.data = {};
                }
            };

            const callbackModal = (param: any) => {
                if (param.action === "confirm") {
                    switch (param.gubun) {
                        case 1:
                            modify(param.path);
                            break;
                        case 2:
                            remove();
                            break;
                        case 3:
                            add();
                            break;
                    }
                } else if (param.action === "callback") {
                    switch (param.gubun) {
                        case 1:
                            detail();

                            break;
                        case 2:
                            router.back();
                            break;
                        case 3:
                            router.push({ name: "complain" });
                            break;
                    }
                    state.isShowModal = false;
                }
            };

            const confirmAdd = () => {
                state.modalTab = 1;
                state.modalTitle = "알림";
                state.modalContent = "정말 등록하시겠습니까?";
                state.isShowModal = true;
                state.gubun = 3;
            };
            const confirmModify = () => {
                state.modalTab = 1;
                state.modalTitle = "알림";
                state.modalContent = "정말 변경하시겠습니까?";
                state.isShowModal = true;
                state.gubun = 1;
            };

            const confirmRemove = () => {
                state.modalTab = 1;
                state.modalTitle = "알림";
                state.modalContent = "정말 삭제하시겠습니까?";
                state.isShowModal = true;
                state.gubun = 2;
            };

            const add = async () => {
                const param: types.complain.ReqComplain = state.data;
                const res = await apiService.complain.add(param);

                if (res.returnCode === 0) {
                    state.modalTab = 3;
                    state.modalTitle = "알림";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                    state.gubun = 3;
                } else {
                    console.error(res.description);
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const modify = async (path?: string) => {
                const param: types.complain.ReqComplainForModify = state.data;
                const res = await apiService.complain.modify(state.idx, param);

                if (res.returnCode === 0) {
                    state.modalTab = 3;
                    state.modalTitle = "알림";
                    state.modalContent = "수정되었습니다.";
                    state.isShowModal = true;
                    state.gubun = 1;
                } else {
                    console.error(res.description);
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const remove = async () => {
                const res = await apiService.complain.remove(Number(route.params.id));
                if (res.returnCode === 0) {
                    state.modalTab = 3;
                    state.modalTitle = "알림";
                    state.modalContent = "삭제되었습니다.";
                    state.isShowModal = true;
                    state.gubun = 2;
                } else {
                    console.error(res.description);
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            return {
                state,
                router,
                reset,
                CommonUtils,
                CommonOptions,
                showModal,
                closeModal,
                callbackModal,
                confirmAdd,
                confirmModify,
                confirmRemove,
                window,
                complainantTypeList,
                typeList,
                resultTypeList,
            };
        },
    };
</script>
